import { useState } from 'react';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import { CheckBox, DateTimeBox, DropDown, TextArea, TextBox } from '../../shared/controls/form';
import Participants from '../../assets/json/participants.json';

const validationSchema = Yup.object().shape({});

const AddMeetingForm = ({
  handleCloseAddForm,
  handleFormSubmit,
  meetingsData,
  open,
  meetingList,
}) => {
  const [formData, setFormData] = useState(meetingsData);
  const [errormsg, setErrorMsg] = useState({});
  const [formEdited, setFormEdited] = useState(false);
  const [showParticipantForm, setShowParticipantForm] = useState(false);
  const [participants, setParticipants] = useState(Participants);
  const [showRepeatForm, setShowRepeatForm] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({});

  const handleChangeForm = (e) => {
    const { name, value } = e.target;
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));
    const convertedValue = value;
    setFormData({
      ...formData,
      [name]: convertedValue,
    });
    setFormEdited(true);
  };

  const handleChange = (selectedOption, name) => {
    setSelectedOptions((prevState) => ({
      ...prevState,
      [name]: selectedOption,
    }));

    handleLookupDropDownChange(selectedOption.value, selectedOption, name);
  };

  const handleLookupDropDownChange = (selectedId, selectedOption, name) => {
    const selectedValue = selectedOption.label;
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));

    const updatedFormData = {
      ...formData,
      [name]: selectedId,
      [`${name}Name`]: selectedValue,
    };
    if (name === 'relatedToId') {
      setFormData({
        ...formData,
        relatedToId: selectedId,
        relatedTo: selectedValue,
      });

      setFormEdited(true);
    }
  };

  const handleSubmit = async (formData) => {
    try {
      await validationSchema.validate(formData, { abortEarly: false });

      handleFormSubmit(formData);
    } catch (error) {
      const fieldErrors = {};
      error.inner.forEach((err) => {
        fieldErrors[err.path] = err.message;
      });
      setErrorMsg(fieldErrors);
      console.error('Validation Error:', fieldErrors);
    }
  };

  const handleDropdownChange = (selectedId, e, name, displayName, flag) => {
    const selectedValue = e.currentTarget.textContent;

    // Update formData with the selected value for the dropdown
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
      [displayName]: undefined,
    }));
    setFormData({
      ...formData,
      [name]: selectedId,
      [displayName]: selectedValue,
    });

    setFormEdited(true);
  };
  const handleAddParticipant = (participant) => {
    setParticipants([...participants, participant]);
    setShowParticipantForm(false);
  };
  const handleCloseParticipants = () => {
    setShowParticipantForm(false);
  };

  const handleCloseRepeat = () => {
    setShowRepeatForm(false);
  };

  const [isExpand, setIsExpand] = useState(false);

  const handleExpand = () => {
    setIsExpand((prev) => !prev);
  };

  return (
    <>
      <div className="modal-form">
        <div
          className={`modal fade ${open ? 'show' : ''}`}
          id="accountModal"
          tabIndex="-1"
          aria-labelledby="dealModalLabel"
          aria-hidden="true"
          style={{
            display: open ? 'flex' : 'none',
            justifyContent: 'center',
          }}
        >
          <div className="modal-overlay">
            <div
              className="modal-dialog"
              style={{
                width: isExpand ? '96vw' : '1085px',
                height: isExpand ? '647px' : '78vh',
                margin: isExpand ? 'auto' : '6px auto',
                maxWidth: 'none',
                top: isExpand ? '30px' : '30px',
                transition: 'width 0.5s ease, height 0.5s ease',
              }}
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title fs-5" id="dealModalLabel">
                    {meetingsData.type === 'add' ? 'New Meeting' : 'Update Meeting'}
                  </h5>
                  <div className="modal_btn_group">
                    <button type="button" className="view_screen">
                      <svg
                        width="18px"
                        height="18px"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M3 4C3 3.44772 3.44772 3 4 3H8C8.55228 3 9 3.44772 9 4C9 4.55228 8.55228 5 8 5H6.41421L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L5 6.41421V8C5 8.55228 4.55228 9 4 9C3.44772 9 3 8.55228 3 8V4ZM16 3H20C20.5523 3 21 3.44772 21 4V8C21 8.55228 20.5523 9 20 9C19.4477 9 19 8.55228 19 8V6.41421L15.7071 9.70711C15.3166 10.0976 14.6834 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L17.5858 5H16C15.4477 5 15 4.55228 15 4C15 3.44772 15.4477 3 16 3ZM9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L6.41421 19H8C8.55228 19 9 19.4477 9 20C9 20.5523 8.55228 21 8 21H4C3.44772 21 3 20.5523 3 20V16C3 15.4477 3.44772 15 4 15C4.55228 15 5 15.4477 5 16V17.5858L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929ZM14.2929 14.2929C14.6834 13.9024 15.3166 13.9024 15.7071 14.2929L19 17.5858V16C19 15.4477 19.4477 15 20 15C20.5523 15 21 15.4477 21 16V20C21 20.5523 20.5523 21 20 21H16C15.4477 21 15 20.5523 15 20C15 19.4477 15.4477 19 16 19H17.5858L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z"
                          fill="#000000"
                        />
                      </svg>
                    </button>
                    <div className="option_menu">
                      <div className="dropdown">
                        <button
                          className="three-dots-btn"
                          id="dropdownMenuButton"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth="1.1"
                          >
                            <circle cx="12" cy="5" r="2"></circle>
                            <circle cx="12" cy="12" r="2"></circle>
                            <circle cx="12" cy="19" r="2"></circle>
                          </svg>
                        </button>
                        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <li>
                            <a className="dropdown-item" href="#">
                              Edit
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item" href="#">
                              Delete
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item" href="#">
                              Settings
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <button
                      type="button"
                      className="custom-btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      onClick={handleCloseAddForm}
                    ></button>
                  </div>
                </div>
                <div className="modal-body">
                  <Formik
                    initialValues={formData}
                    onSubmit={(values) => handleSubmit(values)}
                    validationSchema={validationSchema}
                  >
                    <Form>
                      {showParticipantForm ? (
                        <div className="participant-form">
                          <div className="subHeading">Add Participants</div>
                          <div className="input-container">
                            <DropDown
                              label={'Select Participant From'}
                              name={'participantFromId'}
                              displayName={'participantFrom'}
                              // placeholder={"Enter Participant Name"}
                              handleChange={handleDropdownChange}
                              options={['Contacts', 'Leads', 'Accounts']}
                              // optionKeys={["id","name"]}
                            />
                          </div>
                          <div className="input-container">
                            <ul className="participants-ul">
                              {participants.map((participant, index) => (
                                <li className="participants-li" key={index}>
                                  <div className="participants-parent">
                                    <input
                                      type="checkbox"
                                      name="participants-chk"
                                      id={`participant-${index}`}
                                    />
                                    <div className="participants-details">
                                      <span className="participants-name">{participant.name}</span>
                                      <span className="participants-email">
                                        {participant.email}
                                      </span>
                                    </div>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </div>
                          <div className="input-container">
                            <TextArea
                              label={'Invite By Email'}
                              name={'inviteByEmail'}
                              placeholder={'Enter Emails separated by commas'}
                              handleChange={handleChangeForm}
                            />
                          </div>
                        </div>
                      ) : showRepeatForm ? (
                        <div className="repeat-form">
                          <div className="subHeading">Edit Repeat</div>
                          <div className="input-container">
                            <CheckBox
                              // isRequired={true}
                              label={'All Day'}
                              name={'checkAllDay'}
                              value={formData.checkAllDay}
                              handleChange={handleChangeForm}
                              errormsg={errormsg.checkAllDay}
                            />
                            <div className="input-container">
                              <DateTimeBox
                                label={'From'}
                                name={'fromDateTime'}
                                // placeholder={"MM/DD/YYYY"}
                                value={formData.fromDateTime}
                                handleChange={handleChangeForm}
                                errormsg={formData.fromDateTime}
                              />
                            </div>
                            <div className="input-container">
                              <DateTimeBox
                                label={'To'}
                                name={'toDateTime'}
                                // placeholder={"MM/DD/YYYY"}
                                value={formData.toDateTime}
                                handleChange={handleChangeForm}
                                errormsg={formData.toDateTime}
                              />
                            </div>
                          </div>
                          <div className="input-container">
                            <DropDown
                              label={'Repeat Type'}
                              name={'repeatTypeId'}
                              displayName={'repeatType'}
                              // isRequired={true}
                              placeholder={'Select Repeat Type'}
                              value={formData.repeatType}
                              handleSelect={handleDropdownChange}
                              options={meetingList}
                              optionKeys={['id', 'name']}
                              errormsg={errormsg.repeatTypeId}
                            />
                          </div>
                        </div>
                      ) : (
                        <div className="form">
                          <>
                            <div className="subHeading">Meeting Information</div>
                            <div className="input-container">
                              <TextBox
                                isRequired={true}
                                label={'Meeting Name'}
                                name={'meetingName'}
                                placeholder={'Enter Meeting Name'}
                                value={formData.name}
                                handleChange={handleChangeForm}
                                errormsg={errormsg.meetingName}
                              />
                            </div>

                            <div className="input-container">
                              <TextBox
                                // isRequired={true}
                                label={'Location'}
                                name={'location'}
                                placeholder={'Enter Location'}
                                value={formData.location}
                                handleChange={handleChangeForm}
                                errormsg={errormsg.location}
                              />
                            </div>

                            <div className="input-container">
                              <CheckBox
                                // isRequired={true}
                                label={'Make this an Online Meeting'}
                                name={'checkOnlineMeeting'}
                                value={formData.checkOnlineMeeting}
                                handleChange={handleChangeForm}
                                errormsg={errormsg.checkOnlineMeeting}
                              />
                            </div>
                            <div className="input-container">
                              <CheckBox
                                // isRequired={true}
                                label={'All Day'}
                                name={'checkAllDay'}
                                value={formData.checkAllDay}
                                handleChange={handleChangeForm}
                                errormsg={errormsg.checkAllDay}
                              />
                            </div>

                            <div className="input-container">
                              <DateTimeBox
                                label={'From'}
                                name={'fromDateTime'}
                                // placeholder={"MM/DD/YYYY"}
                                value={formData.from}
                                handleChange={handleChangeForm}
                                errormsg={errormsg.from}
                              />
                            </div>
                            <div className="input-container">
                              <DateTimeBox
                                label={'To'}
                                name={'toDateTime'}
                                // placeholder={"MM/DD/YYYY"}
                                value={formData.to}
                                handleChange={handleChangeForm}
                                errormsg={errormsg.to}
                              />
                            </div>
                            <div className="input-container">
                              <DropDown
                                label={'Host'}
                                name={'hostId'}
                                displayName={'host'}
                                isRequired={true}
                                placeholder={'Host'}
                                value={formData.host}
                                handleSelect={handleDropdownChange}
                                options={meetingList}
                                optionKeys={['id', 'name']}
                                errormsg={errormsg.hostId}
                              />
                            </div>

                            <div className="input-container">
                              <TextBox
                                label={'Related To'}
                                name={'relatedTo'}
                                placeholder={'Enter Related To'}
                                value={formData.relatedTo}
                                handleChange={handleChangeForm}
                                errormsg={errormsg.relatedTo}
                              />
                            </div>

                            <div className="input-container">
                              <label htmlFor="participants">
                                Repeat<span className="required-star">*</span>
                              </label>
                              <div>
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  onClick={() => setShowRepeatForm(true)}
                                >
                                  Edit Repeat
                                </button>
                              </div>
                            </div>
                            <div className="input-container">
                              <DropDown
                                label={'Reminder'}
                                name={'reminderId'}
                                displayName={'reminder'}
                                // isRequired={true}
                                placeholder={'Reminder'}
                                value={formData.reminder}
                                handleSelect={handleDropdownChange}
                                options={meetingList}
                                optionKeys={['id', 'name']}
                                errormsg={errormsg.reminderId}
                              />
                            </div>
                            <div className="input-container">
                              <TextArea
                                // isRequired={true}
                                label={'Description'}
                                name={'description'}
                                placeholder={'Description'}
                                value={formData.description}
                                handleChange={handleChangeForm}
                                errormsg={errormsg.description}
                              />
                            </div>
                          </>
                        </div>
                      )}
                    </Form>
                  </Formik>
                </div>
                <div className="modal-footer">
                  {showParticipantForm ? (
                    <>
                      <button
                        type="button"
                        className="btn btn-outline-primary"
                        onClick={handleCloseParticipants}
                      >
                        Cancel
                      </button>
                    </>
                  ) : showRepeatForm ? (
                    <>
                      <button
                        type="button"
                        className="btn btn-outline-primary"
                        onClick={handleCloseRepeat}
                      >
                        Cancel
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        type="button"
                        className="btn btn-outline-primary"
                        data-bs-dismiss="modal"
                        onClick={handleCloseAddForm}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => handleSubmit(formData)}
                      >
                        Save
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddMeetingForm;
